export { default as animation_loading } from './animation_loading.json';
export { default as create_ai_model } from './create_ai_model.json';
export { default as error_fallback_base } from './error_fallback_base.json';
export { default as fire } from './fire.json';
export { default as loading_fallback_base } from './loading_fallback_base.json';
export { default as not_found } from './not_found.json';
export { default as magic_wand } from './magic-wand.json';
